import { Ref } from "vue";

export interface EasyTimePickerInputProps {
  disabled?: boolean;
  useMeridiem?: boolean;
  maxHours?: number;
  hoursValue: string;
  minutesValue: string;
  meridiemValue: string;
  menuEl?: HTMLDivElement;
}

export interface EasyTimePickerInputEmits {
  (e: "update:timeValue"): void;
  (e: "update:hoursValue", hours: string): void;
  (e: "update:minutesValue", minutes: string): void;
  (e: "update:meridiemValue", meridiem: string): void;
  (e: "blur"): void;
  (e: "focus"): void;
  (e: "change"): void;
}

export interface TimeInputs {
  hours: string;
  minutes: string;
  meridiem: string;
}

export type InputRef = Ref<HTMLInputElement | undefined>;

export interface EasyTimePickerInputs {
  hoursInput: InputRef;
  minutesInput: InputRef;
  meridiemInput: InputRef;
}

export interface EasyTimePickerInputFocuses {
  hours: boolean;
  minutes: boolean;
  meridiem: boolean;
}

export interface EasyTimePickerComposablesData extends EasyTimePickerInputs {
  inputFocuses: EasyTimePickerInputFocuses;
}

export interface EasyTimePickerRootProps {
  name: string;
  label: string;
}

export interface EasyTimePickerDropdownProps {
  disabled?: boolean;
  useMeridiem?: boolean;
  maxHours?: number;
  hoursValue: string;
  minutesValue: string;
  meridiemValue: string;
  menuEl?: HTMLDivElement;
  showDropdownValue: boolean;
}

export interface EasyTimePickerDropdownEmits {
  (e: "update:showDropdownValue", showDropdown: boolean): void;
  (e: "update:timeValue"): void;
  (e: "update:hoursValue", hours: string): void;
  (e: "update:minutesValue", minutes: string): void;
  (e: "update:meridiemValue", meridiem: string): void;
  (e: "change"): void;
}

export interface EasyTimePickerAppPayload {
  props: EasyTimePickerRootProps;
  wrapperId: string;
  hiddenInputId: string;
}

export enum TimeParts {
  Hours = "hours",
  Minutes = "minutes",
  Meridiem = "meridiem", // am/pm
}
